
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[uid]",
      function () {
        return require("private-next-pages/news/[uid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/[uid]"])
      });
    }
  